const KEYS_AND_URLS = {
  UID_ORDER_REQ_KEY: "gzuid",
  REGISTER_USER_URL: "register-user",
  ADMIN_PREVIEW_URL: "adminpreview",
  PAYMENT_METHOD_URL: "payment-method",
  GET_USER: "getuser",
  BILLING_STANDALONE: "billingv2",
  DAILY_REPORTS: {
    SALES: "sales",
    AGGREGATE: "aggregate-sales",
    SHIFT: "shift-reports",
    STAFF_TIMESHEETS: "timesheets",
    WEB_PAYMENTS: "webpayments",
    NO_SHOWS: "no-shows",
  },
  PERIOD_REPORTS: {
    PREPAIDREPORT: "prepaidbalance",
    STAFFSALES_VISIT_REPORT: "staffsales/byvisit",
  },
};

const ROUTE_ACL = {
  SERVICES_ACL: ["operation.view-service", "operation.services"],
  MEMBERSHIP_PLANS_ACL: ["operation.view-service", "operation.services"],
  PREPAID_PLANS_ACL: ["operation.view-service", "operation.services"],
  PREPAID_ITEMS_ACL: ["reporting.giftcards", "reporting.clubmembers"],
  MEMBERSHIP_ITEMS_ACL: ["reporting.giftcards", "reporting.clubmembers"],
  CAMPAIGN_ACL: ["operation.view-campaigns", "operation.campaigns"],
  STAFF_ACL: ["operation.view-staff", "operation.staff"],
  INVENTORY_ACL: ["operation.view-inventory", "operation.inventory"],
  PERIOD_REPORTS_ACL: [
    "reporting.tableview",
    "reporting.campaignreport",
    "reporting.staffreport",
    "reporting.transactionreport",
    "reporting.giftcards",
    "reporting.productreport",
    "reporting.servicereport",
  ],
  STAFF_CUSTOMER_VISIT_REPORT_ACL: ["payroll.staffreport"],
  SETTING_ACL: ["setting.viewsetting", "setting.editsetting"],
  WAIVER_ACL: ["customer"],
  SURVEY_ACL: ["customer"],
  LOCATIONS_ACL: ["locations.view-locations", "locations.edit-locations"],
  TOOLS_ACL: ["tools.deployment", "tools.propay","tools.othertools"],
  LAUNCHPOS_ACL :[ "operation.embeddedPosView"],
  VOICETEXTAI_ACL: ["contentmanagement.voiceandchatagents"],
};

export { KEYS_AND_URLS as default, ROUTE_ACL };
